// Payment provider logos (Wave + Orange Money)
export const WAVE_LOGO_URL = "https://customer-assets.emergentagent.com/job_fundcollect-1/artifacts/r28jxbfy_logo-wave.png";
export const ORANGE_MONEY_LOGO_URL = "https://customer-assets.emergentagent.com/job_fundcollect-1/artifacts/punl05bn_logo-orange-money.png";
